const ManageUsersIndex = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageUsers/ManageUsersIndex')
const ManageUsersActive = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageUsers/ManageUsersActive')
const ManageUsersInactive = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageUsers/ManageUsersInactive')
const ManageUsersImport = () => import(/* webpackChunkName: "admin" */ '@/pages/admin/manageUsers/ManageUsersImport')

export default [
  {
    path: '/admin/manage-users',
    name: 'ManageUsersIndex',
    component: ManageUsersIndex,
    redirect: { name: 'ManageUsersActive' },
    children: [
      {
        path: 'active',
        name: 'ManageUsersActive',
        component: ManageUsersActive
      },
      {
        path: 'inactive',
        name: 'ManageUsersInactive',
        component: ManageUsersInactive
      },
      {
        path: 'import',
        name: 'ManageUsersImport',
        component: ManageUsersImport
      }
    ]
  }
]
